import * as React from 'react'
import styled from 'styled-components'

interface IFNotificationCardMobileLoadingProps {}

const NotificationCardMobileLoading: React.FC<
  IFNotificationCardMobileLoadingProps
> = () => {
  return (
    <StyledWrapper>
      <div className="lt">
        <div className="dot"></div>
        <div className="content">
          <div className="noti-title"></div>
          <div className="noti-subtitle"></div>
          <div className="noti-desc">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div className="rt"></div>
    </StyledWrapper>
  )
}

export default NotificationCardMobileLoading

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: white;
  .lt {
    display: flex;

    .dot {
      height: 24px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      &::after {
        content: '';
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #eee;
        border-radius: 5px;
      }
    }
    .content {
      .noti-title {
        width: 100px;
        height: 24px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 3px;
      }
      .noti-subtitle {
        width: 300px;
        height: 22px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 3px;
      }
      .noti-desc {
        display: flex;
        gap: 10px;
        div {
          width: 50px;
          height: 17px;
          background-color: #eee;
          border-radius: 5px;
        }
      }
    }
  }
  .rt {
    display: flex;
    align-items: center;
    height: 24px;
  }
`
